export function sanity_s3_url_display(url) {
  if (!url) return ''
  url = url.replaceAll(' ', '%20')
  url = url.replaceAll(',', '%2C')
  url = url.replaceAll('+', '%2B')
  url = url.replaceAll('#', '%23')
  return url
}

export function getArtworkInfoUrl(id, name) {
  if (!name) return ''
  let f = name
  f = f.replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '')
  f = f.replaceAll('’', '').replaceAll('?', '').replaceAll('!', '')
  f = f.replaceAll("'", '').replaceAll('.', '').replaceAll(':', '')
  f = f.replaceAll('&', 'and').replaceAll(',', '').replaceAll('#', '')

  return f + '_' + id
}

export function getBlogUrl(id, name) {
  if (!name) return ''
  let f = name
  f = f.replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '')
  f = f.replaceAll('’', '').replaceAll('?', '').replaceAll('!', '')
  f = f.replaceAll("'", '').replaceAll('.', '').replaceAll(':', '')
  f = f.replaceAll('&', 'and').replaceAll(',', '').replaceAll('#', '')

  return id + "_" + f
}

export function getArtworkDetailUrl(id, name) {
  return 'https://revart.co/artworks/info/' + getArtworkInfoUrl(id, name)
}

export function getExhibitionDetailUrl(id, name) {
  if (!name) return ''
  let f = name
  f = f.replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '')
  f = f.replaceAll('’', '').replaceAll('?', '').replaceAll('!', '')
  f = f.replaceAll("'", '').replaceAll('.', '').replaceAll(':', '')
  f = f.replaceAll('&', 'and').replaceAll(',', '').replaceAll('#', '')
  return 'https://revart.co/exhibition/' + id + '_' + f
}

export function getArtistShowcaseUrl(artist_id, artist_name) {
  if (!artist_id || !artist_name) return ''
  let f = artist_name.replace(' ', '_')
  f = f.replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '')
  f = f.replaceAll('’', '').replaceAll('?', '').replaceAll('!', '')
  f = f.replaceAll("'", '').replaceAll('.', '').replaceAll(':', '')
  f = f.replaceAll('&', 'and').replaceAll(',', '').replaceAll('#', '')
  return 'https://revart.co/showcase/' + artist_id+"_"+f
}

export function getEditUrl(base_url, id) {
  if (!base_url) return ''
  return base_url.replaceAll(':id', id)
}

export function getValidYearDisplay(year) {
  if (year === '-1' || year === -1) return ''
  return year
}

export function getPageId(props) {
  let id = props?.match?.params?.id
  if (!id) {
      const locationArray = props?.location?.pathname?.split('/')
      if(locationArray) {
          for(let i = locationArray.length - 1; i > 0; i--) {
              if(!locationArray[i]) continue
              try {
                id = parseInt(locationArray[i])
                return id
              }catch (e) {
                 break
              }
          }
      }
  }
  return id
}

export function stringToColor(str) {
    let col = str.length % 8

    switch (col) {
        case 0:
            return "cyan"
        case 1:
            return "purple"
        case 2:
            return "green"
        case 3:
            return "blue"
        case 4:
            return "geekblue"
        case 5:
            return "lime"
        case 6:
            return "red"
        case 7:
            return "volcano"
    }
}

// const getValidTitleCaseDisplay = (string) => {
//   if (!string || string === '') return ''
//   let strings = string.split(',')
//   strings = strings.map((string) => {
//     const array = string.split('-')
//     const mapped = array.map((a) => {
//       if (!a) return
//       return a[0].toUpperCase() + a.slice(1).toLowerCase()
//     })
//     return mapped.join(' ')
//   })
//   return strings.join(',')
// }
